// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    cta: {
        type: FIELD_TYPES.TEXT,
        label: "CTA",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    sectionVisibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Section Visibility",
        translatable: false
    }
};
